// subscribePresenceAsset.js
'use strict';
import * as MessageTypes from '../serviceWorker/AppMessageTypes.js';
import { sendMessageToSW } from '../serviceWorker/helpers.js';
import getMeData from '../selector/getMeData.js';

/**
 * Subscribe presence asset
 * @kind action
 * @param {string} {assetId} - asset id.
 * @param {string} {uploadJobId} - upload job id.
 * @return {Promise} Action promise.
 */
const subscribePresenceAsset =
  ({ assetId, uploadJobId }) =>
  async (dispatch, getState) => {
    const token = getMeData(getState(), 'token');
    if (!assetId || !token || !uploadJobId) {
      return dispatch({ type: '' });
    }
    return sendMessageToSW({
      type: MessageTypes.SUBSCRIBE_PRESENCE_ASSET_CHANNEL,
      payload: {
        assetId,
        uploadJobId,
      },
    });
  };

export default subscribePresenceAsset;
